<template>
    <div class="main_container">
        <div class="layout_split">
            <RightWing :index="4" :score="score" />
            <div class="main_area" :class="success ? 'correct_color': 'incorrect_color'">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="section_title_container">
                    <div class="section_title">{{sectionTitle}}</div>
                    <div class="article_title">"{{articleTitle}}"</div>
                </div>
                <div class="article_title_mobile">{{articleTitle}}</div>

                <div class="flex_container" :class="success ? 'correct_color': 'incorrect_color'">
                    <div class="flex_item">
                        <div style="text-align:right;"><img :src="playerSaidImg" class="player_said_img"></div>
                        <div class="player_img_position"><img src="../assets/img/player_2.png" class="player_img"></div>
                        <div class="player_text">팩트체커 의견</div>
                    </div>

                    <div class="flex_item">
                        <div style="margin-top:30px;"><img :src="committeeSaidImg" class="committee_said_img"></div>
                        <div v-if="success" class="committee_img_position">
                            <img src="../assets/img/committee_character_success.png" class="committee_img">
                        </div>
                        <div v-else class="committee_img_position">
                            <img src="../assets/img/committee_character_fail.png" class="committee_img">
                        </div>
                        <div class="committee_text">팩트체크위원회 의견</div>
                    </div>
                </div>

                <div class="matching_result">
                    <div v-if="success">
                        <img src="../assets/img/sign_match.png" width="144"> 팩트체크 성공!
                    </div>
                    <div v-else>
                        <img src="../assets/img/sign_unmatch.png" width="144"> 팩트체크 실패!
                    </div>
                </div>

                <div class="btn_container">
                    <div class="btn_ok" :class="buttonOkClass" @click="next">자세히 알아보기</div>
                </div>
                <div class="mobile_margin">space</div>
                    
            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'
export default {
    name: 'JudgementView',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            sectionTitle: null,
            articleTitle: null,
            buttonOkClass: 'btn_ok_active',

            committeeSaid: null,
            committeeSaidImg: null,
            playerSaid: null,
            playerSaidImg: null,

            success: false,
            score: null,
        }
    },

    mounted() {
        let currentGame = this.$getCurrentGame()
        const selectedArticleData = this.$gameData.sections[currentGame.selectedSection].articles[currentGame.selectedArticle]
        this.sectionTitle = this.$gameData.sections[currentGame.selectedSection].title
        this.articleTitle = selectedArticleData.title
        this.score = currentGame.score

        for(let article of currentGame.articles) {
            if(article.title == this.articleTitle) {
                this.playerSaid = article.playerResult
                article.correctResult = selectedArticleData.result
                this.$setCurrentGame(currentGame)
                break;
            }
        }
        
        console.log('player: ' + this.playerSaid)
        if(this.playerSaid == 0) {
            this.playerSaidImg = require('../assets/img/player_true.png')
        }
        else if(this.playerSaid == 1) {
            this.playerSaidImg = require('../assets/img/player_undecided.png')
        }
        else if(this.playerSaid == 2) {
            this.playerSaidImg = require('../assets/img/player_false.png')
        }

        this.committeeSaid = selectedArticleData.result
        console.log('committeeSaid: ' + this.committeeSaid)
        if(this.committeeSaid == '사실') {
            this.committeeSaidImg = require('../assets/img/committee_true.png')
        }
        else if(this.committeeSaid == '판정 보류') {
            this.committeeSaidImg = require('../assets/img/committee_undecided.png')
        }
        else if(this.committeeSaid == '거짓') {
            this.committeeSaidImg = require('../assets/img/committee_false.png')
        }

        if((this.committeeSaid == '사실' && this.playerSaid == 0) ||
                (this.committeeSaid == '판정 보류' && this.playerSaid == 1) ||
                (this.committeeSaid == '거짓' && this.playerSaid == 2)) {
            this.success = true
        }
        else {
            this.success = false
        }
    },

    methods: {
        next: function() {
            // TODO 이전으로 돌아가서 다시 판정하는것 막기? 다시 판정 허용?

            // TODO 결과 저장

            this.$router.push('/articleResult')
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn_ok {
    text-align: center;
    width: 280px;
    padding: 10px;
    margin: 0px 10px;
    border: 2px solid black;
    font-weight: 700;
    font-size: 26px;
    color: black;
    cursor: pointer;
}
.btn_ok_active {
    box-shadow:3px 3px 3px grey;
    background-color: white;
}

.btn_ok_inactive {
    background-color: gray;
}
.btn_container {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}


/* pc */
@media screen and (min-width: 415px) {
    .layout_split {
        display:flex;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display:flex;
        margin-left:20px;
    }
    .article_title_mobile {
        display: none;
    }
    .flex_container {
        display: flex;
        justify-content: center;
        margin:10px 130px;
        background-color:white;
        padding:10px 10px;
    }
    .flex_item {
        width: 320px;
    }
    .mobile_margin {
        display: none;
    }
    .matching_result {
        font-size:35px;
        text-align:center;
    }
    .player_said_img {
        width: 200px;
    }
    .player_img {
        width: 120px;
    }
    .player_text {
        font-size:28px;
        text-align: left;
    }
    .committee_said_img {
        width: 200px;
    }
    .committee_img {
        height: 183px;
    }
    .committee_text {
        font-size:28px;
        text-align: right;
    }
    .player_img_position {
        margin-top: -20px;
    }
    .committee_img_position {
        text-align:right;
        margin-top:-62px;
    }
}


/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display: none;
    }
    .article_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
        /* border-bottom: solid black 1px; */
        text-decoration: underline;
    }
    .flex_container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 10px 10px;
        background-color:white;
        padding: 10px 10px;
    }
    .flex_item {
        width: 320px;
    }
    .mobile_margin {
        margin-bottom: 50px;
        opacity: 0;
    }
    .matching_result {
        font-size: 26px;
        text-align:center;
    }
    .player_said_img {
        width: 200px;
    }
    .player_img {
        width: 70px;
    }
    .player_text {
        font-size: 18px;
        text-align: left;
        font-weight: 700;
    }
    .committee_said_img {
        width: 200px;
    }
    .committee_img {
        height: 128px;
    }
    .committee_text {
        font-weight: 700;
        font-size:18px;
        text-align: right;
    }
    .player_img_position {
        margin-top: -90px;
    }
    .committee_img_position {
        text-align: right;
        margin-top: -102px;
    }
}

.correct_color {
    background-color: #E1FFD3;
}
.incorrect_color {
    background-color: #FFB6B6;
}

</style>
